// getTableColumns.tsx
import { ColumnsType } from 'antd/es/table';

interface TableDataType {
    srno: number;
    category: string;
    dataIndex: string;
    [key: string]: any; // Allows dynamic year-based keys
}

export const GetTempTableColumns = async (
    indicatorId: number,
    t: (key: string) => string,
    fromYearVal: number,
    toYearVal: number
): Promise<ColumnsType<TableDataType>> => {    // const response = await axios.get(`/api/indicators/${indicatorId}/columns`);
    let Skill_Development_Molsw: ColumnsType<TableDataType> = [
        {
            title: `${t('tabletitle.overseas.employment')} ${fromYearVal} - ${fromYearVal + 4}`,
            dataIndex: 'Overseas Employment From',
            align: 'left',
            className: 'tableTitle',
            children: [
                {
                    title: t('indicator.col.srno'),
                    dataIndex: "sr_no",
                    key: "sr_no",
                    sorter: (a, b) => a.sr_no - b.sr_no,
                    fixed: 'left',
                    width: 100
                },
                {
                    title: `${t('indicator.col.category')}`,
                    dataIndex: "category",
                    key: "category",
                    sorter: (a, b) => a.category.localeCompare(b.category),
                    fixed: 'left',
                    width: 360
                },
                {
                    title: `${t('indicator.col.subcategory')}`,
                    dataIndex: "subcategory",
                    key: "subcategory",
                    sorter: (a, b) => a.category.localeCompare(b.subcategory),
                    fixed: 'left',
                    width:150,
                }
            ]
        }];

    for (let index = 0; index < 5; index++) {
        Skill_Development_Molsw.push({
            title: `${fromYearVal + index}`,
            dataIndex: `${fromYearVal}`,
            key: `${fromYearVal}`,
            children: [
                {
                    title: t('indicator.col.total'),
                    dataIndex: `${index + 1}_total`,
                    key: `${index + 1}_total`,
                    sorter: (a, b) => a[`${index + 1}_total`] - b[`${index + 1}_total`],
                    width: 100
                },
                {
                    title: t('indicator.col.female'),
                    dataIndex: `${index + 1}_female`,
                    key: `${index + 1}_female`,
                    sorter: (a, b) => a[`${index + 1}_female`] - b[`${index + 1}_female`],
                    width: 100
                }
            ]
        })
    }

    Skill_Development_Molsw.push(
        {
            title: t('indicator.col.total1'),
            dataIndex: `${t('indicator.col.total')}_1`,
            key: `${t('indicator.col.total')}_1`,
            children: [
                {
                    title: t('indicator.col.total'),
                    dataIndex: "tot_total",
                    key: "tot_total",
                    sorter: (a, b) => a['tot_total'] - b['tot_total'],
                    width: 100
                },
                {
                    title: t('indicator.col.female'),
                    dataIndex: "tot_female",
                    key: "tot_female",
                    sorter: (a, b) => a['tot_female'] - b['tot_female'],
                    width: 100
                }
            ]
        });


    const Family_Registration_MoHA: ColumnsType<TableDataType> =
        [
            {
                title: t('tabletitle.family_registration') + fromYearVal,
                dataIndex: 'Family registration',
                align: 'left',
                className: 'tableTitle',
                children: [
                    // {
                    //     title: t("indicator.col.no"),
                    //     dataIndex: "srNo",
                    //     key: "srNo",
                    //     sorter: (a, b) => a.srNo - b.srNo, // Inline sorting
                    //     width: 60,
                    //     fixed: 'left'
                    // },
                    {
                        title: t("indicator.col.province.code"),
                        dataIndex: "province_code",
                        key: "province_code",
                        sorter: false,
                        // sorter: (a, b) => a.province_name.localeCompare(b.province_name), // Inline sorting
                        width: 150,
                        fixed: 'left'
                    },
                    {
                        title: t("indicator.col.province.name"),
                        dataIndex: "province_name",
                        key: "province_name",
                        sorter: false,
                        // sorter: (a, b) => a.province_name.localeCompare(b.province_name), // Inline sorting
                        width: 150,
                        fixed: 'left'
                    },
                    
                    {
                        title: t("indicator.col.birth.registration.a.year"),
                        children: [
                            {
                                title: t("indicator.col.total"),
                                dataIndex: "birth_reg_within_a_year_total",
                                key: "birth_reg_within_a_year_total",
                                sorter: (a, b) => a.birth_reg_within_a_year_total - b.birth_reg_within_a_year_total, // Inline sorting
                                width: 140
                            },
                            {
                                title: t("indicator.col.female"),
                                dataIndex: "birth_reg_within_a_year_female",
                                key: "birth_reg_within_a_year_female",
                                sorter: (a, b) => a.birth_reg_within_a_year_female - b.birth_reg_within_a_year_female, // Inline sorting
                                width: 140
                            },
                        ],
                    },
                    {
                        title: t("indicator.col.birth.registration.under5.year"),
                        children: [
                            {
                                title: t("indicator.col.total"),
                                dataIndex: "birth_reg_under_5_years_age_total",
                                key: "birth_reg_under_5_years_age_total",
                                sorter: (a, b) => a.birth_reg_under_5_years_age_total - b.birth_reg_under_5_years_age_total, // Inline sorting
                                width: 140
                            },
                            {
                                title: t("indicator.col.female"),
                                dataIndex: "birth_reg_under_5_years_age_female",
                                key: "birth_reg_under_5_years_age_female",
                                sorter: (a, b) => a.birth_reg_under_5_years_age_female - b.birth_reg_under_5_years_age_female, // Inline sorting
                                width: 140
                            },
                        ],
                    },
                    {
                        title: t("indicator.col.birth.registration.upper5.year"),
                        children: [
                            {
                                title: t("indicator.col.total"),
                                dataIndex: "birth_reg_upper_5_years_age_total",
                                key: "birth_reg_upper_5_years_age_total",
                                sorter: (a, b) => a.birth_reg_upper_5_years_age_total - b.birth_reg_upper_5_years_age_total, // Inline sorting
                                width: 140
                            },
                            {
                                title: t("indicator.col.female"),
                                dataIndex: "birth_reg_upper_5_years_of_age_female",
                                key: "birth_reg_upper_5_years_of_age_female",
                                sorter: (a, b) => a.birth_reg_upper_5_years_of_age_female - b.birth_reg_upper_5_years_of_age_female, // Inline sorting
                                width: 140
                            },
                        ],
                    },
                    {
                        title: t("indicator.col.marriage.registration"),
                        children: [
                            {
                                title: t("indicator.col.lao.Lao"),
                                dataIndex: "marriage_reg_lao_lao",
                                key: "marriage_reg_lao_lao",
                                sorter: (a, b) => a.marriage_reg_lao_lao - b.marriage_reg_lao_lao, // Inline sorting
                                width: 200
                            },
                            {
                                title: t("indicator.col.lao.foreigner"),
                                dataIndex: "marriage_reg_lao_foreigner",
                                key: "marriage_reg_lao_foreigner",
                                sorter: (a, b) => a.marriage_reg_lao_foreigner - b.marriage_reg_lao_foreigner, // Inline sorting
                                width: 220

                            },
                            {
                                title: t("indicator.col.lao.alien"),
                                dataIndex: "marriage_reg_lao_alien",
                                key: "marriage_reg_lao_alien",
                                sorter: (a, b) => a.marriage_reg_lao_alien - b.marriage_reg_lao_alien, // Inline sorting
                                width: 200
                            },
                            {
                                title: t("indicator.col.lao.statelessperson"),
                                dataIndex: "marriage_reg_lao_stateless_person",
                                key: "marriage_reg_lao_stateless_person",
                                sorter: (a, b) => a.marriage_reg_lao_stateless_person - b.marriage_reg_lao_stateless_person, // Inline sorting
                                width: 230
                            },
                        ],
                    },
                    {
                        title: t("indicator.col.divorce.registration"),
                        children: [
                            {
                                title: t("indicator.col.lao.Lao"),
                                dataIndex: "divorce_reg_lao_lao",
                                key: "divorce_reg_lao_lao",
                                sorter: (a, b) => a.divorce_reg_lao_lao - b.divorce_reg_lao_lao, // Inline sorting
                                width: 200
                            },
                            {
                                title: t("indicator.col.lao.foreigner"),
                                dataIndex: "divorce_reg_lao_foreigner",
                                key: "divorce_reg_lao_foreigner",
                                sorter: (a, b) => a.divorce_reg_lao_foreigner - b.divorce_reg_lao_foreigner, // Inline sorting
                                width: 220
                            },
                            {
                                title: t("indicator.col.lao.alien"),
                                dataIndex: "divorce_reg_lao_Alien",
                                key: "divorce_reg_lao_Alien",
                                sorter: (a, b) => a.divorce_reg_lao_Alien - b.divorce_reg_lao_Alien, // Inline sorting
                                width: 200
                            },
                            {
                                title: t("indicator.col.lao.statelessperson"),
                                dataIndex: "divorce_reg_lao_stateless_person",
                                key: "divorce_reg_lao_stateless_person",
                                sorter: (a, b) => a.divorce_reg_lao_stateless_person - b.divorce_reg_lao_stateless_person, // Inline sorting
                                width: 230
                            },
                        ],
                    },
                    {
                        title: t("indicator.col.register.changeofname"),
                        children: [
                            {
                                title: t("indicator.col.total"),
                                dataIndex: "reg_change_of_name_total",
                                key: "reg_change_of_name_total",
                                sorter: (a, b) => a.reg_change_of_name_total - b.reg_change_of_name_total, // Inline sorting
                                width: 110
                            },
                            {
                                title: t("indicator.col.female"),
                                dataIndex: "reg_change_of_name_female",
                                key: "reg_change_of_name_female",
                                sorter: (a, b) => a.reg_change_of_name_female - b.reg_change_of_name_female, // Inline sorting
                                width: 110
                            },
                        ],
                    },
                    {
                        title: t("indicator.col.register.changeofsurname"),
                        children: [
                            {
                                title: t("indicator.col.total"),
                                dataIndex: "reg_change_of_surname_total",
                                key: "reg_change_of_surname_total",
                                sorter: (a, b) => a.reg_change_of_surname_total - b.reg_change_of_surname_total, // Inline sorting
                                width: 110
                            },
                            {
                                title: t("indicator.col.female"),
                                dataIndex: "reg_change_of_surname_female",
                                key: "reg_change_of_surname_female",
                                sorter: (a, b) => a.reg_change_of_surname_female - b.reg_change_of_surname_female, // Inline sorting
                                width: 110
                            },
                        ],
                    },
                    {
                        title: t("indicator.col.register.changeofnationality"),
                        children: [
                            {
                                title: t("indicator.col.total"),
                                children: [
                                    {
                                        title: t("indicator.col.total"),
                                        dataIndex: "reg_change_of_national_total_total",
                                        key: "reg_change_of_national_total_total",
                                        sorter: (a, b) => a.reg_change_of_national_total_total - b.reg_change_of_national_total_total, // Inline sorting
                                        width: 100
                                    },
                                    {
                                        title: t("indicator.col.female"),
                                        dataIndex: "reg_change_of_national_total_female",
                                        key: "reg_change_of_national_total_female",
                                        sorter: (a, b) => a.reg_change_of_national_total_female - b.reg_change_of_national_total_female, // Inline sorting
                                        width: 100
                                    },
                                ],
                            },
                            {
                                title: t("indicator.col.lao.citizenship.granting"),
                                children: [
                                    {
                                        title: t("indicator.col.total"),
                                        dataIndex: "reg_change_of_national_lao_citizen_granting_total",
                                        key: "reg_change_of_national_lao_citizen_granting_total",
                                        sorter: (a, b) => a.reg_change_of_national_lao_citizen_granting_total - b.reg_change_of_national_lao_citizen_granting_total, // Inline sorting
                                        width: 100
                                    },
                                    {
                                        title: t("indicator.col.female"),
                                        dataIndex: "reg_change_of_national_lao_citizen_granting_female",
                                        key: "reg_change_of_national_lao_citizen_granting_female",
                                        sorter: (a, b) => a.reg_change_of_national_lao_citizen_granting_female - b.reg_change_of_national_lao_citizen_granting_female, // Inline sorting
                                        width: 100
                                    },
                                ],
                            },
                            {
                                title: t("indicator.col.lao.citizenship.restoration"),
                                children: [
                                    {
                                        title: t("indicator.col.total"),
                                        dataIndex: "reg_change_of_national_lao_citizen_restoration_total",
                                        key: "reg_change_of_national_lao_citizen_restoration_total",
                                        sorter: (a, b) => a.reg_change_of_national_lao_citizen_restoration_total - b.reg_change_of_national_lao_citizen_restoration_total, // Inline sorting
                                        width: 100
                                    },
                                    {
                                        title: t("indicator.col.female"),
                                        dataIndex: "reg_change_of_national_lao_citizen_restoration_female",
                                        key: "reg_change_of_national_lao_citizen_restoration_female",
                                        sorter: (a, b) => a.reg_change_of_national_lao_citizen_restoration_female - b.reg_change_of_national_lao_citizen_restoration_female, // Inline sorting
                                        width: 100
                                    },
                                ],
                            },
                            {
                                title: t("indicator.col.lao.citizenship.revocation"),
                                children: [
                                    {
                                        title: t("indicator.col.total"),
                                        dataIndex: "reg_change_of_national_lao_citizen_revocation_total",
                                        key: "reg_change_of_national_lao_citizen_revocation_total",
                                        sorter: (a, b) => a.reg_change_of_national_lao_citizen_revocation_total - b.reg_change_of_national_lao_citizen_revocation_total, // Inline sorting
                                        width: 100
                                    },
                                    {
                                        title: t("indicator.col.female"),
                                        dataIndex: "reg_change_of_national_lao_citizen_revocation_female",
                                        key: "reg_change_of_national_lao_citizen_revocation_female",
                                        sorter: (a, b) => a.reg_change_of_national_lao_citizen_revocation_female - b.reg_change_of_national_lao_citizen_revocation_female, // Inline sorting
                                        width: 100
                                    },
                                ],
                            },
                            {
                                title: t("indicator.col.lao.citizenship.abandonment"),
                                children: [
                                    {
                                        title: t("indicator.col.total"),
                                        dataIndex: "reg_change_of_national_lao_citizen_abandonment_total",
                                        key: "reg_change_of_national_lao_citizen_abandonment_total",
                                        sorter: (a, b) => a.reg_change_of_national_lao_citizen_abandonment_total - b.reg_change_of_national_lao_citizen_abandonment_total, // Inline sorting
                                        width: 110
                                    },
                                    {
                                        title: t("indicator.col.female"),
                                        dataIndex: "reg_change_of_national_lao_citizen_abandonment_female",
                                        key: "reg_change_of_national_lao_citizen_abandonment_female",
                                        sorter: (a, b) => a.reg_change_of_national_lao_citizen_abandonment_female - b.reg_change_of_national_lao_citizen_abandonment_female, // Inline sorting
                                        width: 110
                                    },
                                ],
                            },
                        ],
                    },

                    {
                        title: t("indicator.col.move-in.registration"),
                        children: [
                            {
                                title: t("indicator.col.total"),
                                children: [
                                    {
                                        title: t("indicator.col.total"),
                                        dataIndex: "move_in_reg_total_total",
                                        key: "move_in_reg_total_total",
                                        sorter: (a, b) => a.move_in_reg_total_total - b.move_in_reg_total_total, // Inline sorting
                                        width: 100
                                    },
                                    {
                                        title: t("indicator.col.female"),
                                        dataIndex: "move_in_reg_total_female",
                                        key: "move_in_reg_total_female",
                                        sorter: (a, b) => a.move_in_reg_total_female - b.move_in_reg_total_female, // Inline sorting
                                        width: 100
                                    },
                                ],
                            },
                            {
                                title: t("indicator.col.village"),
                                children: [
                                    {
                                        title: t("indicator.col.total"),
                                        dataIndex: "move_in_reg_village_village_total",
                                        key: "move_in_reg_village_village_total",
                                        sorter: (a, b) => a.move_in_reg_village_village_total - b.move_in_reg_village_village_total, // Inline sorting
                                        width: 100
                                    },
                                    {
                                        title: t("indicator.col.female"),
                                        dataIndex: "move_in_reg_village_village_female",
                                        key: "move_in_reg_village_village_female",
                                        sorter: (a, b) => a.move_in_reg_village_village_female - b.move_in_reg_village_village_female, // Inline sorting
                                        width: 100
                                    },
                                ],
                            },
                            {
                                title: t("indicator.col.district"),
                                children: [
                                    {
                                        title: t("indicator.col.total"),
                                        dataIndex: "move_in_reg_district_district_total",
                                        key: "move_in_reg_district_district_total",
                                        sorter: (a, b) => a.move_in_reg_district_district_total - b.move_in_reg_district_district_total, // Inline sorting
                                        width: 100
                                    },
                                    {
                                        title: t("indicator.col.female"),
                                        dataIndex: "move_in_reg_district_district_female",
                                        key: "move_in_reg_district_district_female",
                                        sorter: (a, b) => a.move_in_reg_district_district_female - b.move_in_reg_district_district_female, // Inline sorting
                                        width: 100
                                    },
                                ],
                            },
                            {
                                title: t("indicator.col.province"),
                                children: [
                                    {
                                        title: t("indicator.col.total"),
                                        dataIndex: "move_in_reg_province_province_total",
                                        key: "move_in_reg_province_province_total",
                                        sorter: (a, b) => a.move_in_reg_province_province_total - b.move_in_reg_province_province_total, // Inline sorting
                                        width: 100
                                    },
                                    {
                                        title: t("indicator.col.female"),
                                        dataIndex: "move_in_reg_province_province_female",
                                        key: "move_in_reg_province_province_female",
                                        sorter: (a, b) => a.move_in_reg_province_province_female - b.move_in_reg_province_province_female, // Inline sorting
                                        width: 100
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        title: t("indicator.col.move-out.registration"),
                        children: [
                            {
                                title: t("indicator.col.total"),
                                children: [
                                    {
                                        title: t("indicator.col.total"),
                                        dataIndex: "move_out_reg_total_total",
                                        key: "move_out_reg_total_total",
                                        sorter: (a, b) => a.move_out_reg_total_total - b.move_out_reg_total_total, // Inline sorting
                                        width: 100
                                    },
                                    {
                                        title: t("indicator.col.female"),
                                        dataIndex: "move_out_reg_total_female",
                                        key: "move_out_reg_total_female",
                                        sorter: (a, b) => a.move_out_reg_total_female - b.move_out_reg_total_female, // Inline sorting
                                        width: 100
                                    },
                                ],
                            },
                            {
                                title: t("indicator.col.village"),
                                children: [
                                    {
                                        title: t("indicator.col.total"),
                                        dataIndex: "move_out_reg_village_village_total",
                                        key: "move_out_reg_village_village_total",
                                        sorter: (a, b) => a.move_out_reg_village_village_total - b.move_out_reg_village_village_total,
                                        width: 100
                                    },
                                    {
                                        title: t("indicator.col.female"),
                                        dataIndex: "move_out_reg_village_village_female",
                                        key: "move_out_reg_village_village_female",
                                        sorter: (a, b) => a.move_out_reg_village_village_female - b.move_out_reg_village_village_female,
                                        width: 100
                                    },
                                ],
                            },
                            {
                                title: t("indicator.col.district"),
                                children: [
                                    {
                                        title: t("indicator.col.total"),
                                        dataIndex: "move_out_reg_district_district_total",
                                        key: "move_out_reg_district_district_total",
                                        sorter: (a, b) => a.move_out_reg_district_district_total - b.move_out_reg_district_district_total,
                                        width: 100
                                    },
                                    {
                                        title: t("indicator.col.female"),
                                        dataIndex: "move_out_reg_district_district_female",
                                        key: "move_out_reg_district_district_female",
                                        sorter: (a, b) => a.move_out_reg_district_district_female - b.move_out_reg_district_district_female,
                                        width: 100
                                    },
                                ],
                            },
                            {
                                title: t("indicator.col.province"),
                                children: [
                                    {
                                        title: t("indicator.col.total"),
                                        dataIndex: "move_out_reg_province_province_total",
                                        key: "move_out_reg_province_province_total",
                                        sorter: (a, b) => a.move_out_reg_province_province_total - b.move_out_reg_province_province_total,
                                        width: 100
                                    },
                                    {
                                        title: t("indicator.col.female"),
                                        dataIndex: "move_out_reg_province_province_female",
                                        key: "move_out_reg_province_province_female",
                                        sorter: (a, b) => a.move_out_reg_province_province_female - b.move_out_reg_province_province_female,
                                        width: 100
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        title: t("indicator.col.death.reg.lower5"),
                        children: [
                            {
                                title: t("indicator.col.total"),
                                dataIndex: "death_reg_lower_5_years_total",
                                key: "death_reg_lower_5_years_total",
                                sorter: (a, b) => a.death_reg_lower_5_years_total - b.death_reg_lower_5_years_total,
                                width: 150
                            },
                            {
                                title: t("indicator.col.female"),
                                dataIndex: "death_reg_lower_5_years_female",
                                key: "death_reg_lower_5_years_female",
                                sorter: (a, b) => a.death_reg_lower_5_years_female - b.death_reg_lower_5_years_female,
                                width: 150
                            },
                        ],
                    },
                    {
                        title: t("indicator.col.death.reg.over5"),
                        children: [
                            {
                                title: t("indicator.col.total"),
                                dataIndex: "death_reg_over_5_years_total",
                                key: "death_reg_over_5_years_total",
                                sorter: (a, b) => a.death_reg_over_5_years_total - b.death_reg_over_5_years_total,
                                width: 150
                            },
                            {
                                title: t("indicator.col.female"),
                                dataIndex: "death_reg_over_5_years_female",
                                key: "death_reg_over_5_years_female",
                                sorter: (a, b) => a.death_reg_over_5_years_female - b.death_reg_over_5_years_female,
                                width: 150
                            },
                        ],
                    },
                ]
            },
        ];

    const Entrance_Exit_Data_Foreign_Nationals_MoPS: ColumnsType<TableDataType> = [
        {
            title: `${t('tabletitle.foreign_nationalone')} ${fromYearVal} - ${toYearVal}`,
            dataIndex: 'Foreign National',
            align: 'left',
            className: 'tableTitle',
            children: [
                {
                    title: t("indicator.col.year"),
                    dataIndex: "year",
                    key: "year",
                    sorter: (a, b) => a.id - b.id, // Inline sorting
                    fixed: 'left',
                    width: 80
                },
                {
                    title: t("indicator.col.male"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "male_ent",
                            key: "male_ent",
                            sorter: (a, b) => a.male_ent - b.male_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "male_exit",
                            key: "male_exit",
                            sorter: (a, b) => a.male_exit - b.male_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.female"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "female_ent",
                            key: "female_ent",
                            sorter: (a, b) => a.female_ent - b.female_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "female_exit",
                            key: "female_exit",
                            sorter: (a, b) => a.female_exit - b.female_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.children"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "children_ent",
                            key: "children_ent",
                            sorter: (a, b) => a.children_ent - b.children_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "children_exit",
                            key: "children_exit",
                            sorter: (a, b) => a.children_exit - b.children_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.total"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "total_ent",
                            key: "total_ent",
                            sorter: (a, b) => a.total_ent - b.total_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "total_exit",
                            key: "total_exit",
                            sorter: (a, b) => a.total_exit - b.total_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.diplomatic"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "diplomatic_ent",
                            key: "diplomatic_ent",
                            sorter: (a, b) => a.diplomatic_ent - b.diplomatic_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "diplomatic_exit",
                            key: "diplomatic_exit",
                            sorter: (a, b) => a.diplomatic_exit - b.diplomatic_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.official"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "official_ent",
                            key: "official_ent",
                            sorter: (a, b) => a.official_ent - b.official_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "official_exit",
                            key: "official_exit",
                            sorter: (a, b) => a.official_exit - b.official_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.visit"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "visit_ent",
                            key: "visit_ent",
                            sorter: (a, b) => a.visit_ent - b.visit_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "visit_exit",
                            key: "visit_exit",
                            sorter: (a, b) => a.visit_exit - b.visit_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.business"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "business_ent",
                            key: "business_ent",
                            sorter: (a, b) => a.business_ent - b.business_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "business_exit",
                            key: "business_exit",
                            sorter: (a, b) => a.business_exit - b.business_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.tourism"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "tourism_ent",
                            key: "tourism_ent",
                            sorter: (a, b) => a.tourism_ent - b.tourism_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "tourism_exit",
                            key: "tourism_exit",
                            sorter: (a, b) => a.tourism_exit - b.tourism_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.transit"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "transit_ent",
                            key: "transit_ent",
                            sorter: (a, b) => a.transit_ent - b.transit_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "transit_exit",
                            key: "transit_exit",
                            sorter: (a, b) => a.transit_exit - b.transit_exit,
                            width: 100
                        },
                    ],
                },
            ]
        }
    ];


    const Entrance_Exit_Data_Lao_Nationals_MoPS: ColumnsType<TableDataType> = [
        {
            title: `${t('tabletitle.lao.nationalone')} ${fromYearVal} - ${toYearVal}`,
            dataIndex: 'Lao national',
            align: 'left',
            className: 'tableTitle',
            children: [
                {
                    title: t("indicator.col.year"),
                    dataIndex: "year",
                    key: "year",
                    sorter: (a, b) => a.year - b.year,
                    fixed: 'left',
                    width: 80
                },
                {
                    title: t("indicator.col.male"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "male_ent",
                            key: "male_ent",
                            sorter: (a, b) => a.male_ent - b.male_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "male_exit",
                            key: "male_exit",
                            sorter: (a, b) => a.male_exit - b.male_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.female"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "female_ent",
                            key: "female_ent",
                            sorter: (a, b) => a.female_ent - b.female_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "female_exit",
                            key: "female_exit",
                            sorter: (a, b) => a.female_exit - b.female_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.children"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "children_ent",
                            key: "children_ent",
                            sorter: (a, b) => a.children_ent - b.children_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "children_exit",
                            key: "children_exit",
                            sorter: (a, b) => a.children_exit - b.children_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.total"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "total_ent",
                            key: "total_ent",
                            sorter: (a, b) => a.total_ent - b.total_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "total_exit",
                            key: "total_exit",
                            sorter: (a, b) => a.total_exit - b.total_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.diplomatic"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "diplomatic_ent",
                            key: "diplomatic_ent",
                            sorter: (a, b) => a.diplomatic_ent - b.diplomatic_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "diplomatic_exit",
                            key: "diplomatic_exit",
                            sorter: (a, b) => a.diplomatic_exit - b.diplomatic_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.official"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "official_ent",
                            key: "official_ent",
                            sorter: (a, b) => a.official_ent - b.official_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "official_exit",
                            key: "official_exit",
                            sorter: (a, b) => a.official_exit - b.official_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.visit"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "visit_ent",
                            key: "visit_ent",
                            sorter: (a, b) => a.visit_ent - b.visit_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "visit_exit",
                            key: "visit_exit",
                            sorter: (a, b) => a.visit_exit - b.visit_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.business"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "business_ent",
                            key: "business_ent",
                            sorter: (a, b) => a.business_ent - b.business_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "business_exit",
                            key: "business_exit",
                            sorter: (a, b) => a.business_exit - b.business_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.tourism"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "tourism_ent",
                            key: "tourism_ent",
                            sorter: (a, b) => a.tourism_ent - b.tourism_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "tourism_exit",
                            key: "tourism_exit",
                            sorter: (a, b) => a.tourism_exit - b.tourism_exit,
                            width: 100
                        },
                    ],
                },
                {
                    title: t("indicator.col.transit"),
                    children: [
                        {
                            title: t("indicator.col.ent"),
                            dataIndex: "transit_ent",
                            key: "transit_ent",
                            sorter: (a, b) => a.transit_ent - b.transit_ent,
                            width: 100
                        },
                        {
                            title: t("indicator.col.exit"),
                            dataIndex: "transit_exit",
                            key: "transit_exit",
                            sorter: (a, b) => a.transit_exit - b.transit_exit,
                            width: 100
                        },
                    ],
                },
            ]
        }
    ];


    const Statistics_of_Lao_Population_MoHA: ColumnsType<TableDataType> = [
        {
            title: t('tabletitle.statistics_lao') + fromYearVal,
            dataIndex: 'Statistics of Lao population',
            align: 'left',
            className: 'tableTitle',
            children: [
                // {
                //     title: t("indicator.col.no"),
                //     dataIndex: "srNo",
                //     key: "srNo",
                //     sorter: (a, b) => a.srNo - b.srNo,
                //     fixed: 'left',
                //     width: 60
                // },
                {
                    title: t("indicator.col.province.code"),
                    dataIndex: "province_code",
                    key: "province_code",
                    sorter: false,
                    // sorter: (a, b) => a.province_name.localeCompare(b.province_name), // Inline sorting
                    width: 150,
                    fixed: 'left'
                },
                {
                    title: t("indicator.col.province.name"),
                    dataIndex: "province_name",
                    key: "province_name",
                    sorter: false,
                    // sorter: (a, b) => a.province_name.localeCompare(b.province_name), // Inline sorting
                    fixed: 'left',
                    width: 150
                },
                {
                    title: t("indicator.col.no.of.district"),
                    width: 150,
                    children: [
                        {
                            title: t("indicator.col.total"),
                            dataIndex: "num_of_district_total",
                            key: "num_of_district_total",
                            sorter: (a, b) => a.num_of_district_total - b.num_of_district_total,
                            width: 150
                        },
                    ],
                },
                {
                    title: t("indicator.col.no.of.village"),
                    children: [
                        {
                            title: t("indicator.col.total"),
                            dataIndex: "num_of_village_total",
                            key: "num_of_village_total",
                            sorter: (a, b) => a.num_of_village_total - b.num_of_village_total,
                            width: 150
                        },
                    ],
                },
                {
                    title: t("indicator.col.no.of.unit"),
                    children: [
                        {
                            title: t("indicator.col.total"),
                            dataIndex: "num_of_unit_total",
                            key: "num_of_unit_total",
                            sorter: (a, b) => a.num_of_unit_total - b.num_of_unit_total,
                            width: 150
                        },
                    ],
                },
                {
                    title: t("indicator.col.no.of.family"),
                    children: [
                        {
                            title: t("indicator.col.total"),
                            dataIndex: "num_of_family_total",
                            key: "num_of_family_total",
                            sorter: (a, b) => a.num_of_family_total - b.num_of_family_total,
                            width: 150
                        },
                    ],
                },
                {
                    title: t("indicator.col.no.of.laospopulation"),
                    children: [
                        {
                            title: t("indicator.col.total"),
                            dataIndex: "num_laos_population_in_2022_total",
                            key: "num_laos_population_in_2022_total",
                            sorter: (a, b) => a.num_laos_population_in_2022_total - b.num_laos_population_in_2022_total,
                            width: 150
                        },
                        {
                            title: t("indicator.col.female"),
                            dataIndex: "num_laos_population_in_2022_female",
                            key: "num_laos_population_in_2022_female",
                            sorter: (a, b) => a.num_laos_population_in_2022_female - b.num_laos_population_in_2022_female,
                            width: 150
                        },
                    ],
                },
                {
                    title: t("indicator.col.birth.notification"),
                    children: [
                        {
                            title: t("indicator.col.total"),
                            dataIndex: "Birth_notification_total",
                            key: "Birth_notification_total",
                            sorter: (a, b) => a.Birth_notification_total - b.Birth_notification_total,
                            width: 150
                        },
                        {
                            title: t("indicator.col.female"),
                            dataIndex: "Birth_notification_female",
                            key: "Birth_notification_female",
                            sorter: (a, b) => a.Birth_notification_female - b.Birth_notification_female,
                            width: 150
                        },
                    ],
                },
                {
                    title: t("indicator.col.married.proposal.under18"),
                    children: [
                        {
                            title: t("indicator.col.lao.Lao"),
                            dataIndex: "married_proposal_under_18_years_old_lao_lao",
                            key: "married_proposal_under_18_years_old_lao_lao",
                            sorter: (a, b) => a.married_proposal_under_18_years_old_lao_lao - b.married_proposal_under_18_years_old_lao_lao,
                            width: 200
                        },
                        {
                            title: t("indicator.col.lao.foreigner"),
                            dataIndex: "married_proposal_under_18_years_lao_foreigner",
                            key: "married_proposal_under_18_years_lao_foreigner",
                            sorter: (a, b) => a.married_proposal_under_18_years_lao_foreigner - b.married_proposal_under_18_years_lao_foreigner,
                            width: 250
                        },
                        {
                            title: t("indicator.col.lao.alien"),
                            dataIndex: "married_proposal_under_18_years_lao_alien",
                            key: "married_proposal_under_18_years_lao_alien",
                            sorter: (a, b) => a.married_proposal_under_18_years_lao_alien - b.married_proposal_under_18_years_lao_alien,
                            width: 250
                        },
                        {
                            title: t("indicator.col.lao.statelessperson"),
                            dataIndex: "married_proposal_under_18_year_lao_stateless_person",
                            key: "married_proposal_under_18_year_lao_stateless_person",
                            sorter: (a, b) => a.married_proposal_under_18_year_lao_stateless_person - b.married_proposal_under_18_year_lao_stateless_person,
                            width: 250
                        },
                    ],
                },
                {
                    title: t("indicator.col.married.proposal.upper18"),
                    children: [
                        {
                            title: t("indicator.col.lao.Lao"),
                            dataIndex: "married_proposal_upper_18_years_old_lao_lao",
                            key: "married_proposal_upper_18_years_old_lao_lao",
                            sorter: (a, b) => a.married_proposal_upper_18_years_old_lao_lao - b.married_proposal_upper_18_years_old_lao_lao,
                            width: 200
                        },
                        {
                            title: t("indicator.col.lao.foreigner"),
                            dataIndex: "married_proposal_upper_18_years_old_lao_foreigner",
                            key: "married_proposal_upper_18_years_old_lao_foreigner",
                            sorter: (a, b) => a.married_proposal_upper_18_years_old_lao_foreigner - b.married_proposal_upper_18_years_old_lao_foreigner,
                            width: 250
                        },
                        {
                            title: t("indicator.col.lao.alien"),
                            dataIndex: "married_proposal_upper_18_years_old_lao_alln",
                            key: "married_proposal_upper_18_years_old_lao_alln",
                            sorter: (a, b) => a.married_proposal_upper_18_years_old_lao_alln - b.married_proposal_upper_18_years_old_lao_alln,
                            width: 250
                        },
                        {
                            title: t("indicator.col.lao.statelessperson"),
                            dataIndex: "married_proposal_upper_18_years_old_lao_stateless_person",
                            key: "married_proposal_upper_18_years_old_lao_stateless_person",
                            sorter: (a, b) => a.married_proposal_upper_18_years_old_lao_stateless_person - b.married_proposal_upper_18_years_old_lao_stateless_person,
                            width: 250
                        },
                    ],
                },
                {
                    title: t("indicator.col.uncontested.divorce"),
                    children: [
                        {
                            title: t("indicator.col.lao.Lao"),
                            dataIndex: "uncontested_divorce_Lao_Lao",
                            key: "uncontested_divorce_Lao_Lao",
                            sorter: (a, b) => a.uncontested_divorce_Lao_Lao - b.uncontested_divorce_Lao_Lao,
                            width: 200
                        },
                        {
                            title: t("indicator.col.lao.foreigner"),
                            dataIndex: "uncontested_divorce_Lao_Foreigner",
                            key: "uncontested_divorce_Lao_Foreigner",
                            sorter: (a, b) => a.uncontested_divorce_Lao_Foreigner - b.uncontested_divorce_Lao_Foreigner,
                            width: 250
                        },
                        {
                            title: t("indicator.col.lao.alien"),
                            dataIndex: "uncontested_divorce_Lao_Alien",
                            key: "uncontested_divorce_Lao_Alien",
                            sorter: (a, b) => a.uncontested_divorce_Lao_Alien - b.uncontested_divorce_Lao_Alien,
                            width: 250
                        },
                        {
                            title: t("indicator.col.lao.statelessperson"),
                            dataIndex: "uncontested_divorce_Lao_Stateless_person",
                            key: "uncontested_divorce_Lao_Stateless_person",
                            sorter: (a, b) => a.uncontested_divorce_Lao_Stateless_person - b.uncontested_divorce_Lao_Stateless_person,
                            width: 250
                        },
                    ],
                },
                {
                    title: t("indicator.col.register.changeofname"),
                    children: [
                        {
                            title: t("indicator.col.total"),
                            dataIndex: "reg_change_name_total",
                            key: "reg_change_name_total",
                            sorter: (a, b) => a.reg_change_name_total - b.reg_change_name_total,
                            width: 150
                        },
                        {
                            title: t("indicator.col.female"),
                            dataIndex: "reg_change_name_female",
                            key: "reg_change_name_female",
                            sorter: (a, b) => a.reg_change_name_female - b.reg_change_name_female,
                            width: 150
                        },
                    ],
                },
                {
                    title: t("indicator.col.register.changeofsurname"),
                    children: [
                        {
                            title: t("indicator.col.total"),
                            dataIndex: "reg_change_surname_total",
                            key: "reg_change_surname_total",
                            sorter: (a, b) => a.reg_change_surname_total - b.reg_change_surname_total,
                            width: 150
                        },
                        {
                            title: t("indicator.col.female"),
                            dataIndex: "reg_change_surname_female",
                            key: "reg_change_surname_female",
                            sorter: (a, b) => a.reg_change_surname_female - b.reg_change_surname_female,
                            width: 150
                        },
                    ],
                },
                {
                    title: t("indicator.col.move-in.request"),
                    children: [
                        {
                            title: t("indicator.col.total"),
                            children: [
                                {
                                    title: t("indicator.col.total"),
                                    dataIndex: "move_in_request_total_total",
                                    key: "move_in_request_total_total",
                                    sorter: (a, b) => a.move_in_request_total_total - b.move_in_request_total_total,
                                    width: 150
                                },
                                {
                                    title: t("indicator.col.female"),
                                    dataIndex: "move_in_request_total_female",
                                    key: "move_in_request_total_female",
                                    sorter: (a, b) => a.move_in_request_total_female - b.move_in_request_total_female,
                                    width: 150
                                },
                            ],
                        },
                        {
                            title: t("indicator.col.village"),
                            children: [
                                {
                                    title: t("indicator.col.total"),
                                    dataIndex: "move_in_request_village_village_total",
                                    key: "move_in_request_village_village_total",
                                    sorter: (a, b) => a.move_in_request_village_village_total - b.move_in_request_village_village_total,
                                    width: 150
                                },
                                {
                                    title: t("indicator.col.female"),
                                    dataIndex: "move_in_request_village_village_female",
                                    key: "move_in_request_village_village_female",
                                    sorter: (a, b) => a.move_in_request_village_village_female - b.move_in_request_village_village_female,
                                    width: 150
                                },
                            ],
                        },
                        {
                            title: t("indicator.col.district"),
                            children: [
                                {
                                    title: t("indicator.col.total"),
                                    dataIndex: "move_in_request_district_district_total",
                                    key: "move_in_request_district_district_total",
                                    sorter: (a, b) => a.move_in_request_district_district_total - b.move_in_request_district_district_total,
                                    width: 150
                                },
                                {
                                    title: t("indicator.col.female"),
                                    dataIndex: "move_in_request_district_district_female",
                                    key: "move_in_request_district_district_female",
                                    sorter: (a, b) => a.move_in_request_district_district_female - b.move_in_request_district_district_female,
                                    width: 150
                                },
                            ],
                        },
                        {
                            title: t("indicator.col.province"),
                            children: [
                                {
                                    title: t("indicator.col.total"),
                                    dataIndex: "move_in_request_Province_Province_total",
                                    key: "move_in_request_Province_Province_total",
                                    sorter: (a, b) => a.move_in_request_Province_Province_total - b.move_in_request_Province_Province_total,
                                    width: 150
                                },
                                {
                                    title: t("indicator.col.female"),
                                    dataIndex: "move_in_request_Province_Province_female",
                                    key: "move_in_request_Province_Province_female",
                                    sorter: (a, b) => a.move_in_request_Province_Province_female - b.move_in_request_Province_Province_female,
                                    width: 150
                                },
                            ],
                        },
                    ],
                },
                {
                    title: t("indicator.col.move-out.request"),
                    children: [
                        {
                            title: t("indicator.col.total"),
                            children: [
                                {
                                    title: t("indicator.col.total"),
                                    dataIndex: "move_out_request_total_total",
                                    key: "move_out_request_total_total",
                                    sorter: (a, b) => a.move_out_request_total_total - b.move_out_request_total_total,
                                    width: 150
                                },
                                {
                                    title: t("indicator.col.female"),
                                    dataIndex: "move_out_request_total_female",
                                    key: "move_out_request_total_female",
                                    sorter: (a, b) => a.move_out_request_total_female - b.move_out_request_total_female,
                                    width: 150
                                },
                            ],
                        },
                        {
                            title: t("indicator.col.village"),
                            children: [
                                {
                                    title: t("indicator.col.total"),
                                    dataIndex: "move_out_request_village_village_total",
                                    key: "move_out_request_village_village_total",
                                    sorter: (a, b) => a.move_out_request_village_village_total - b.move_out_request_village_village_total,
                                    width: 150
                                },
                                {
                                    title: t("indicator.col.female"),
                                    dataIndex: "move_out_request_village_village_female",
                                    key: "move_out_request_village_village_female",
                                    sorter: (a, b) => a.move_out_request_village_village_female - b.move_out_request_village_village_female,
                                    width: 150
                                },
                            ],
                        },
                        {
                            title: t("indicator.col.district"),
                            children: [
                                {
                                    title: t("indicator.col.total"),
                                    dataIndex: "move_out_request_district_district_total",
                                    key: "move_out_request_district_district_total",
                                    sorter: (a, b) => a.move_out_request_district_district_total - b.move_out_request_district_district_total,
                                    width: 150
                                },
                                {
                                    title: t("indicator.col.female"),
                                    dataIndex: "move_out_request_district_district_female",
                                    key: "move_out_request_district_district_female",
                                    sorter: (a, b) => a.move_out_request_district_district_female - b.move_out_request_district_district_female,
                                    width: 150
                                },
                            ],
                        },
                        {
                            title: t("indicator.col.province"),
                            children: [
                                {
                                    title: t("indicator.col.total"),
                                    dataIndex: "move_out_request_Province_Province_total",
                                    key: "move_out_request_Province_Province_total",
                                    sorter: (a, b) => a.move_out_request_Province_Province_total - b.move_out_request_Province_Province_total,
                                    width: 150
                                },
                                {
                                    title: t("indicator.col.female"),
                                    dataIndex: "move_out_request_Province_Province_total",
                                    key: "move_out_request_Province_Province_total",
                                    sorter: (a, b) => a.move_out_request_Province_Province_total - b.move_out_request_Province_Province_total,
                                    width: 150
                                },
                            ],
                        },
                    ],
                },
                {
                    title: t("indicator.col.death.notification"),
                    children: [
                        {
                            title: t("indicator.col.total"),
                            children: [
                                {
                                    title: t("indicator.col.total"),
                                    dataIndex: "death_notification_total_total",
                                    key: "death_notification_total_total",
                                    sorter: (a, b) => a.death_notification_total_total - b.death_notification_total_total,
                                    width: 150
                                },
                                {
                                    title: t("indicator.col.female"),
                                    dataIndex: "death_notification_total_female",
                                    key: "death_notification_total_female",
                                    sorter: (a, b) => a.death_notification_total_female - b.death_notification_total_female,
                                    width: 150
                                },
                            ],
                        },
                        {
                            title: t("indicator.col.lower.5.years"),
                            children: [
                                {
                                    title: t("indicator.col.total"),
                                    dataIndex: "death_notification_Lower_5_years_total",
                                    key: "death_notification_Lower_5_years_total",
                                    sorter: (a, b) => a.death_notification_Lower_5_years_total - b.death_notification_Lower_5_years_total,
                                    width: 150
                                },
                                {
                                    title: t("indicator.col.female"),
                                    dataIndex: "death_notification_Lower_5_years_female",
                                    key: "death_notification_Lower_5_years_female",
                                    sorter: (a, b) => a.death_notification_Lower_5_years_female - b.death_notification_Lower_5_years_female,
                                    width: 150
                                },
                            ],
                        },
                        {
                            title: t("indicator.col.over.5.years"),
                            children: [
                                {
                                    title: t("indicator.col.total"),
                                    dataIndex: "death_notification_Over_5_years_total",
                                    key: "death_notification_Over_5_years_total",
                                    sorter: (a, b) => a.death_notification_Over_5_years_total - b.death_notification_Over_5_years_total,
                                    width: 200
                                },
                                {
                                    title: t("indicator.col.female"),
                                    dataIndex: "death_notification_Over_5_years_female",
                                    key: "death_notification_Over_5_years_female",
                                    sorter: (a, b) => a.death_notification_Over_5_years_female - b.death_notification_Over_5_years_female,
                                    width: 220
                                },
                            ],
                        },
                    ]
                },
                {
                    title: t("indicator.col.total.lao.population"),
                    children: [
                        {
                            title: t("indicator.col.total"),
                            dataIndex: "total_lao_population_total",
                            key: "total_lao_population_total",
                            sorter: (a, b) => a.total_lao_population_total - b.total_lao_population_total,
                            width: 220
                        },
                        {
                            title: t("indicator.col.female"),
                            dataIndex: "total_lao_population_female",
                            key: "total_lao_population_female",
                            sorter: (a, b) => a.total_lao_population_female - b.total_lao_population_female,
                            width: 220
                        },
                    ],
                },
            ]
        }
    ];


    let Total_Statistics_Molsw: ColumnsType<TableDataType> = [
        {
            title: `${t('tabletitle.statics.summary')} (${fromYearVal} ${t('to')} ${fromYearVal + 4})`,
            dataIndex: 'Statics Summary of figures for 5 years',
            align: 'left',
            className: 'tableTitle',
            children: [
                {
                    title: t('indicator.col.srno'),
                    dataIndex: "sr_no",
                    key: "sr_no",
                    sorter: (a, b) => a.sr_no - b.sr_no,
                    fixed: 'left',
                    width: 100
                },
                {
                    title: `${t('indicator.col.category')}`,
                    dataIndex: "category",
                    key: "category",
                    sorter: (a, b) => a.category.localeCompare(b.category),
                    fixed: 'left',
                    width: 360
                },
                {
                    title: `${t('indicator.col.subcategory')}`,
                    dataIndex: "subcategory",
                    key: "subcategory",
                    sorter: (a, b) => a.category.localeCompare(b.subcategory),
                    fixed: 'left',
                    width: 150
                }
            ]
        }];

    for (let index = 0; index < 5; index++) {

        Total_Statistics_Molsw.push(
            {
                title: `${fromYearVal + index}-${fromYearVal + index + 1}`,
                dataIndex: `${fromYearVal + index}`,
                key: `${fromYearVal + index}`,
                children: [
                    {
                        title: t('indicator.col.total'),
                        dataIndex: `${index + 1}_total`,
                        key: `${index + 1}_total`,
                        sorter: (a, b) => a[`${index + 1}_total`] - b[`${index + 1}_total`],
                        width: 100
                    },
                    {
                        title: t('indicator.col.female'),
                        dataIndex: `${index + 1}_female`,
                        key: `${index + 1}_female`,
                        sorter: (a, b) => a[`${index + 1}_female`] - b[`${index + 1}_female`],
                        width: 100
                    }
                ]
            });
    }

    Total_Statistics_Molsw.push(
        {
            title: t('indicator.col.total1'),
            dataIndex: `${t('indicator.col.total')}_1`,
            key: `${t('indicator.col.total')}_1`,
            children: [
                {
                    title: t('indicator.col.total'),
                    dataIndex: "tot_total",
                    key: "tot_total",
                    sorter: (a, b) => a['tot_total'] - b['tot_total'],
                    width: 100
                },
                {
                    title: t('indicator.col.female'),
                    dataIndex: "tot_female",
                    key: "tot_female",
                    sorter: (a, b) => a['tot_female'] - b['tot_female'],
                    width: 100
                }
            ]
        });

    switch (indicatorId) {
        case 9:
            return Skill_Development_Molsw;
        case 11:
            return Entrance_Exit_Data_Foreign_Nationals_MoPS;
        case 13:
            return Family_Registration_MoHA;
        case 14:
            return Total_Statistics_Molsw;
        case 15:
            return Entrance_Exit_Data_Lao_Nationals_MoPS;
        case 16:
            return Statistics_of_Lao_Population_MoHA;
        default:
            return Entrance_Exit_Data_Foreign_Nationals_MoPS;
    }
};


